module.exports = __webpack_public_path__ + "img/组 127(1).f7106575.png";